<div style="display:flex; flex-direction:row">
  <div style="width: 20%;"></div>
<div class="container" *ngIf="archiveJob">
  <mat-toolbar color="primary" class="toolbar-over-card">
    <mat-card-title>Edit Archive Job</mat-card-title>
  </mat-toolbar>
  <mat-card appearance="outlined" class="scrollable-content">
    <mat-card-content [formGroup]="archiveJobFormGroup">
      <div class="form-control-wrapper">
        <mat-form-field>
          <mat-label>Title</mat-label>
          <input matInput placeholder="Archive Job title" formControlName="title" />
        </mat-form-field>
      </div>
      <div class="form-control-wrapper">
        <mat-form-field>
          <mat-label>Comments</mat-label>
          <textarea matInput placeholder="Archive Job Comments" cdkTextareaAutosize
                    formControlName="comments" style="min-height: 100px;"></textarea>
        </mat-form-field>
      </div>
      <div class="form-control-wrapper">
        <mat-form-field>
          <mat-label>Archive Base</mat-label>
          <input matInput placeholder="Archive Base" formControlName="archiveBaseNumberStart" />
        </mat-form-field>
      </div>
      <div class="form-control-wrapper">
        <mat-form-field>
          <mat-label>Number of Digits</mat-label>
          <mat-select formControlName="archiveBaseNumberDigits">
            <mat-option *ngFor="let digit of numberOfDigits" [value]="digit" [style.height.px]="40">
              <div>{{digit}}</div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-control-wrapper">
        <mat-form-field>
          <mat-label>Archive Type</mat-label>
          <mat-select formControlName="isCreateTiff">
            <mat-option *ngFor="let archiveType of archiveTypes" [value]="archiveType.value === true" [style.height.px]="40">
              <div>{{archiveType.displayName}}</div>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-card-content>
    <mat-card-actions align="right">
      <button mat-button color="primary" [disabled]="isSaveDisabled()" (click)="save()">Save</button>
      <button mat-button color="primary" (click)="cancel()">Cancel</button>
    </mat-card-actions>
  </mat-card>
</div>
  <div style="width: 20%;"></div>
</div>